import * as angular from "angular";
import { HouseOccupantDataProvider } from "../../data-provider/house-occupant.dp";
import { HouseOccupant } from "../../models/house-occupant.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { DuplicatesDataProvider } from "../../data-provider/duplicates.dp";

let DuplicateDialog = {
    selector: "vcDuplicateDialog",
    templateUrl:
        "/angular/components/duplicates/duplicate-dialog.component.html",
    bindings: {
        duplicate: "=?",
    },
    controller: class DuplicateDialogController {
        // * bindings for typescript compiler *
        public duplicate?: any;
        // ************************************

        private $q: any;
        public __env: any;

        private dataProvider: DuplicatesDataProvider;
        private houseOccupantDataProvider: HouseOccupantDataProvider;
        public permissionProvider: PermissionCheck;

        private dialog: DialogUtils;
        private toast: ToastUtils;

        public selected: HouseOccupant;
        public notSelected: HouseOccupant;
        public explainExpanded = false;

        constructor(
            $q: any,
            __env: any,
            PermissionCheck: PermissionCheck,
            DuplicatesDataProvider: DuplicatesDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            HouseOccupantDataProvider: HouseOccupantDataProvider
        ) {
            this.$q = $q;
            this.__env = __env;

            this.dataProvider = DuplicatesDataProvider;
            this.houseOccupantDataProvider = HouseOccupantDataProvider;
            this.permissionProvider = PermissionCheck;

            this.dialog = DialogUtils;
            this.toast = ToastUtils;
        }

        $onInit() {
            let houseOccupantsPromises: Promise<void>[] = [];
            angular.forEach(
                this.duplicate.houseoccupants,
                (houseOccupant: HouseOccupant, $index: number) => {
                    const deferred = this.$q.defer();
                    houseOccupantsPromises.push(deferred.promise);
                    this.houseOccupantDataProvider
                        .getHouseOccupant(houseOccupant.hoid)
                        .then((detailedHouseOccupant: HouseOccupant) => {
                            this.duplicate.houseoccupants[$index] =
                                detailedHouseOccupant;
                            deferred.resolve();
                        });
                }
            );

            this.$q.all(houseOccupantsPromises).then(
                () => {
                    this.selected = this.duplicate.houseoccupants.primary;
                    this.setNotSelected();
                },
                () => this.toast.error()
            );
        }

        setNotSelected(): void {
            angular.forEach(
                this.duplicate.houseoccupants,
                (houseoccupant: HouseOccupant) => {
                    if (
                        houseoccupant.hoid &&
                        houseoccupant.hoid != this.selected.hoid
                    ) {
                        this.notSelected = houseoccupant;
                    }
                }
            );
        }
        confirm(): void {
            this.dataProvider
                .merge(this.selected, this.notSelected)
                .then((data: object) => {
                    this.dialog.hide({
                        primary: data,
                        secondary: this.notSelected,
                    });
                });
        }

        cancel(): void {
            this.dialog.cancel();
        }

        setSelected(houseoccupant: HouseOccupant): void {
            this.selected = houseoccupant;
            this.setNotSelected();
        }
    },
};

angular
    .module("duplicates", [])
    .component(DuplicateDialog.selector, DuplicateDialog);
